import styled from "styled-components";
import { BiSearch, BiX } from "react-icons/bi"
import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGeneralResults } from "../../../../hooks/useGeneralSearch";
import { useIsMobile } from "../../../../hooks/useWidth";

interface SearchProps {
  isSearchShown: boolean;
}

export function Search() {
  const [isSearchShown, setIsSearchShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  let history = useNavigate();

  const isMobile = useIsMobile();  

  async function submitForm(e: any) {
    e.preventDefault();
    const data = await search();
    history(
      '/pesquisa', 
      {
        state: {
          data 
        }
      }
    ); 
  }

  const toggleSearch = (e: MouseEvent<HTMLButtonElement>, show: boolean) => {
    e.preventDefault();
    setIsSearchShow(show);
  }

  async function search() {
    const result = await getGeneralResults({
      search_text: searchTerm,
      initialDate: '',
      finalDate: '',
      categoria: '',
      indice: ''
    });
    return result;
  }
  
  return (
    <Content>
      <ButtonDesktop onClick={(e) => toggleSearch(e, true)}>
        <SearchIcon size={20} />
      </ButtonDesktop>
      <Form isSearchShown={isSearchShown} onSubmit={submitForm}>
        <Input
          type="text"
          placeholder="Digite sua busca aqui"
          value={searchTerm}
          onChange={({ target }) => setSearchTerm(target?.value)}
        />
        <Button>
          <SearchIcon size={isMobile ? 32 : 20} />
        </Button>
        <Close onClick={(e) => toggleSearch(e, false)}>
          <CloseIcon size={28} />
        </Close>
      </Form>
    </Content>
  );
}

const Content = styled.div`
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: fixed;
    bottom: 32px;
    left: 32px;
    right: 32px;
  }
`;

const Button = styled.button`
  background: ${({ theme }) => theme.colors.blue.darker};
  border: none;
  width: 80px;
  height: 70px;
  position: relative;
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    background-color: #fff;
    height: 52px;
    width: 52px;

    * {
      color: ${({ theme }) => theme.colors.blue.darker};
    }
  }
`;

const ButtonDesktop = styled(Button)`
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;

const Close = styled(Button)`
  &::before {
    content: "";
    height: 32px;
    width: 1px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;

const SearchIcon = styled(BiSearch)`
  color: #fff;
  position: absolute;
  top: calc(50% + 2px);
  left: 50%;
  transform: translate(-50%, -50%);
`;

const CloseIcon = styled(BiX)`
  color: #fff;
  position: absolute;
  top: calc(50% + 2px);
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Form = styled.form<SearchProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.blue.darker};
  padding-left: 32px;
  display: flex;
  align-items: center;
  opacity: ${({ isSearchShown }) => isSearchShown ? 1 : 0};
  visibility: ${({ isSearchShown }) => isSearchShown ? 'visible' : 'hidden'};
  transition: all 0.2s;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: static;
    opacity: 1;
    visibility: visible;
    background-color: #fff;
    padding: 0;
    border-radius: 4px;
    overflow: hidden;
  }
`;

const Input = styled.input`
  width: 100%;
  height: 36px;
  background: transparent;
  border: none;
  border-bottom: 2px solid #fff;
  color: #fff;
  padding: 16px;
  outline: none;
  font-size: 18px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    border: none;
    height: 52px;
    color: ${({ theme }) => theme.colors.blue.darker};
  }
`;